import { useState } from "react";
import {
  TextField,
  Button,
  Alert,
  Stack,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { loginUser, setAuthToken } from "../../api";
import { useDispatch } from "react-redux";
import { login } from "../../store/authSlice";

export default function LoginForm({ onLoginSuccess }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [msg, setMsg] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const dispatch = useDispatch();

  const handleLogin = async (e) => {
    e.preventDefault();
    setMsg("");
    setSubmitting(true);

    try {
      const res = await loginUser(username, password);
      const data = res.data;

      const token = data.access;
      const usernameFromApi = data.user?.username || username;
      const isAdmin = !!data.user?.is_staff;

      // Om du vill fortsätta med expires_at lokalt:
      const expiresAt = Date.now() + 15 * 60 * 1000; // matcha ACCESS-lifetime (15 min, från backend)
      localStorage.setItem("expires_at", String(expiresAt));

      localStorage.setItem("token", token);
      localStorage.setItem("username", usernameFromApi);
      localStorage.setItem("is_admin", String(isAdmin));

      setAuthToken(token);
      dispatch(
        login({
          token,
          username: usernameFromApi,
          is_admin: isAdmin,
          expires_at: expiresAt,
        })
      );

      onLoginSuccess?.();
    } catch (err) {
      const detail =
        err?.response?.data?.detail || "Fel användarnamn eller lösenord.";
      setMsg(detail);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Stack component="form" onSubmit={handleLogin} spacing={2} sx={{ pt: 0.5 }}>
      {msg && (
        <Alert severity="error" variant="filled">
          {msg}
        </Alert>
      )}

      <TextField
        label="Användarnamn"
        name="username"
        placeholder="Användarnamn"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        required
        fullWidth
        size="small"
        autoComplete="username"
      />

      <TextField
        label="Lösenord"
        name="password"
        type={showPwd ? "text" : "password"}
        placeholder="Lösenord"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
        fullWidth
        size="small"
        autoComplete="current-password"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowPwd((v) => !v)}
                edge="end"
                aria-label={showPwd ? "Göm lösenord" : "Visa lösenord"}
                size="small"
                sx={{
                  color: "accent.main",
                }}
              >
                {showPwd ? <BsEyeSlash /> : <BsEye />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      <Button
        type="submit"
        fullWidth
        disabled={submitting}
        variant="contained"
        sx={{ mt: 1 }}
      >
        {submitting ? "Loggar in…" : "Logga in"}
      </Button>
    </Stack>
  );
}
